import { render, staticRenderFns } from "./CustomerV2.vue?vue&type=template&id=46bd2e2c"
import script from "./CustomerV2.vue?vue&type=script&lang=js"
export * from "./CustomerV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports